// extracted by mini-css-extract-plugin
module.exports = {"nav__submenu":"NavSubmenu_nav__submenu__QMUa0","nav__submenu--opened":"NavSubmenu_nav__submenu--opened__TzeVw"};